module.exports = require('./helpers/bundle-url').getBundleURL('UckoE') + "ivan-ros-navarro.497624c7.jpg" + "?" + Date.now();